import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "ean" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 2,
  class: "label-boxes"
}
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_label_box = _resolveComponent("label-box")!
  const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon")!
  const _component_MinusCircleIcon = _resolveComponent("MinusCircleIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["product-variant-card", { editing: _ctx.editing }]),
    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onVariantClick && _ctx.onVariantClick(...args)), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.productVariant.ean?.[0] ?? ''), 1),
      (!_ctx.editing)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString(_ctx.productVariant.title), 1))
        : (_openBlock(), _createBlock(_component_q_input, {
            key: 1,
            class: "q-small-input title-input",
            dense: "",
            outlined: "",
            placeholder: "Title",
            ref: "titleInput",
            "model-value": _ctx.productVariant.title,
            "onUpdate:modelValue": _ctx.onTitleUpdate
          }, null, 8, ["model-value", "onUpdate:modelValue"])),
      (Object.keys(_ctx.variantOptions).length && _ctx.productVariant.components?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.variantOptions, (value, propId) => {
              return (_openBlock(), _createBlock(_component_label_box, {
                "model-value": value,
                label: _ctx.productOptionNames[propId],
                options: (_ctx.propValueOptions[propId] ?? []).filter(vo => vo.value !== value),
                "onUpdate:modelValue": ($event: any) => (_ctx.$emit('update:option-value', [propId, $event])),
                editing: _ctx.editing,
                key: propId
              }, null, 8, ["model-value", "label", "options", "onUpdate:modelValue", "editing"]))
            }), 128))
          ]))
        : (_ctx.editing)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Variant doesn't have stock items"))
          : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (!_ctx.editing)
        ? (_openBlock(), _createBlock(_component_ChevronRightIcon, {
            key: 0,
            class: "link-icon",
            size: "22px",
            onClick: _ctx.onVariantClick
          }, null, 8, ["onClick"]))
        : (_openBlock(), _createBlock(_component_MinusCircleIcon, {
            key: 1,
            class: "unlink",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('unlink:product-variant')))
          }))
    ])
  ], 2))
}